import ValueList from "slotworks/utils/value-list";

class GambleModel {
    public gambleChoices: ValueList<string> = new ValueList();

    public setDefaults(options: string[]) {
        this.gambleChoices.values = options;
        this.gambleChoices.defaultValue = undefined;

        this.setGambleOption();
    }

    public getCurrentChoice(): string | undefined {
        return this.gambleChoices.currentValue;
    }

    public getOption(index: number): string {
        this.setGambleOption(this.gambleChoices.values[index]);
        return this.gambleChoices.currentValue;
    }

    private setGambleOption(value?: string) {
        if (this.gambleChoices.currentValue !== value) {
            this.gambleChoices.currentValue = value;
        }
    }
}

export default new GambleModel();
